import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const make = defineConnector({
  identifier: "make",
  name: "Make",
  tagLine: "Workflow automation platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ environmentUrl }) => domainToRegex(environmentUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Find your Make API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Make](https://www.make.com/) account, go to your profile icon in the bottom-left, then select **Profile > API**. Click **Add token**, give it a name, and select the scopes you need.",
        },
      ],
    },
    {
      title: "Connect your Make account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Make instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Domain",
          placeholder: "us1.make.com",
          required: true,
          target: { kind: "configuration", field: "environmentUrl" },
          helperText:
            "Your Make instance domain, e.g. 'us1.make.com' or 'eu1.make.com'.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Make account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.environmentUrl}/api/v2/users/me`,
  },
  publicEnvVars: ({ environmentUrl }) => ({
    MAKE_ENVIRONMENT_URL: environmentUrl || "",
  }),
});
